import * as React from 'react';
import {enhance} from './enhancer';
import {Link} from 'react-router-dom';
import Table from '@/migration/table/Table';
import {Field} from 'redux-form';
import {Search} from '@/migration/search';

import {Icon} from 'semantic-ui-react';
import {BansTableColumns} from './../../../components/Bans';
import {config} from './../../../config';
import {lifecycle} from './lifecycle';
import {setState} from './state';
import {handler} from './handler';

import './index.scss';

function BansMain(props: any) {
  const {paths} = config;
  const state = setState();
  lifecycle.componentDidMount(state, props);

  return (
    <div className="a__bans-main">
      <div className="b__title c__after-title">
        <h1 style={{fontFamily: 'UD Shin Go Medium'}}> 禁止ワード </h1>
      </div>
      <div className="b__sub">
        <div className="b__search">
          <Field
            name="searchWord"
            component={Search}
            placeholder="検索ワードを入力"
            addSearchWord={handler.addSearchWord(state, props)}
            searchWords={props.bans.searchWords}
            removeSearchWord={handler.removeSearchWord(state, props)}
            outline
          />
        </div>
        <div className="b__create">
          <Link to={paths.bans.create}>
            <span>
              <Icon name="add" />
              禁止ワードを追加する
            </span>
          </Link>
        </div>
      </div>
      <div className="b__bans">
        <Table
          active={props.bans.pages.active}
          columns={BansTableColumns(props)}
          current={props.bans.current}
          totalCount={props.bans.totalCount}
          loading={state.loading || props.bans.loading}
          updateCurrent={handler.updateCurrent(state, props)}
          disabled={state.disabled}
          sortState={props.bans.sortState}
          updateSortState={handler.updateSortState(state, props)}
          pageSize={50}
        />
      </div>
    </div>
  );
}

export default enhance((props: any) => <BansMain {...props} />);
